import { BaseText, Meta, theme } from 'aimo-ui';
import AccountContext from 'context/AccountContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { ColumnWithMargins, StyledWrapper } from 'styles/ContainerStyles';
import { CountryCode, Maybe } from 'types/generatedSchemaTypes';
import { currencyFormatter } from 'utils/commonUtils';
import {
  getPromotionText,
  getPromotionValidityText,
  PromotionLike,
} from 'utils/promotionUtils';

const LineThroughText = styled.Text`
  text-decoration-line: line-through;
  text-decoration-style: solid;
`;

type PromotionInfoProps = {
  promotion: Maybe<PromotionLike> | undefined;
  country: Maybe<CountryCode> | undefined;
  labelKey?: string;
  testID?: string;
  originalPrice?: number;
  discountedPrice?: number;
};

const PromotionInfo = ({
  promotion,
  country,
  labelKey = 'permit.promotion',
  testID,
  originalPrice,
  discountedPrice,
}: PromotionInfoProps) => {
  const { t } = useTranslation();
  const {
    customer: { preferredLanguage },
  } = useContext(AccountContext);

  if (!promotion) {
    return null;
  }

  const promotionText = getPromotionText(
    promotion,
    country,
    preferredLanguage,
    labelKey,
    t
  );
  const validityText = getPromotionValidityText(promotion.validity);
  const showPriceComparison =
    country && originalPrice !== undefined && discountedPrice !== undefined;

  return (
    <ColumnWithMargins mt={5}>
      <StyledWrapper center mb={0}>
        <Meta color={theme.colors.gray300} testID={`${testID}-promotion-type`}>
          {promotionText}
        </Meta>
      </StyledWrapper>
      {validityText && (
        <StyledWrapper center mt={0} mb={0}>
          <Meta
            color={theme.colors.gray300}
            testID={`${testID}-promotion-validity`}>
            {validityText}
          </Meta>
        </StyledWrapper>
      )}
      {showPriceComparison && (
        <StyledWrapper center mt={0}>
          <Meta testID={`${testID}-promotion-price`}>
            <LineThroughText>
              <BaseText color={theme.colors.gray300}>
                {currencyFormatter(originalPrice, country)}
              </BaseText>
            </LineThroughText>
            <BaseText color={theme.colors.black}>
              {' ' + currencyFormatter(discountedPrice, country)}
            </BaseText>
          </Meta>
        </StyledWrapper>
      )}
    </ColumnWithMargins>
  );
};

export default PromotionInfo;
